var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"load"},[(_vm.isShowHint)?_c('cube-loading'):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.hint))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }